import defaultLangs from './ReactDualListBox/js/lang/default'

export const getDualListBoxLabels = (props: any) => {
  return {
    ...defaultLangs,
    ...props,
  }
}
